import { render } from "./UntradingApp.vue?vue&type=template&id=240747a1"
import script from "./UntradingApp.vue?vue&type=script&lang=js"
export * from "./UntradingApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__